import { render, staticRenderFns } from "./TaxComponent.vue?vue&type=template&id=f5aee668&scoped=true&"
import script from "./TaxComponent.vue?vue&type=script&lang=js&"
export * from "./TaxComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5aee668",
  null
  
)

export default component.exports